import { hexToRgb, rgbToHex } from '@/features/instructions/lib/hexColor'

export const darken = (hex: string, amount = 0.1): string => {
  const rgb = hexToRgb(hex)
  if (!rgb) return hex
  return rgbToHex(rgb.r * (1 - amount), rgb.g * (1 - amount), rgb.b * (1 - amount))
}

export const getShadowColor = (gradient: string): string => {
  const hexes = gradient.match(/#[0-9a-fA-F]{6}/g)
  if (!hexes || hexes.length === 0) return 'rgba(0,0,0,0.10)'
  return darken(hexes[0], 0.1)
}

export const SHADOW_OFFSET = 0.06
